module.exports = __webpack_public_path__ + "img/write_icon.2bc143fa.svg";